import { Component, ElementRef, EventEmitter, HostListener, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ChartConfiguration, ChartType, ChartData, ChartOptions } from 'chart.js';
import { BaseChartDirective, NgChartsModule } from 'ng2-charts';
import { AdminInsurerStackItem, masterProvider, MonthlyData, StatusDataForProvider } from '../../models/phase1models';
import { MemberInsurerRestService } from '../../services/member-insurer-rest.service';
import { CommonModule } from '@angular/common';
import { MemberInsurerServiceService } from '../../services/member-insurer-service.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Router } from '@angular/router';
import { LoaderComponent } from "../shared/loader/loader.component";
import { InitialsPipe } from "../shared/pipes/intials.pipe";
import { Roles } from '../../models/commonmodel';
import { DashboardSummary } from '../../models/modeladmins';
@Component({
  selector: 'app-super-admin-dashboard',
  standalone: true,
  imports: [NgChartsModule, MatFormFieldModule, FormsModule, MatInputModule, CommonModule, LoaderComponent, InitialsPipe],
  templateUrl: './super-admin-dashboard.component.html',
  styleUrl: './super-admin-dashboard.component.scss',
  animations: [
    trigger('cardVisibility', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.9) translateY(10px)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'scale(1) translateY(0)' }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0, transform: 'scale(0.9) translateY(-10px)' }))
      ])
    ]),
    trigger('userCardAnimation', [
      state('unselected', style({
        transform: 'scale(1)',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
        borderColor: 'transparent'
      })),
      state('selected', style({
        transform: 'scale(1.03)',
        borderColor: '#0075C9',
        background: 'linear-gradient(157deg, rgb(0 117 201 / 0%), rgb(102 174 224 / 20%))'
      })),
      transition('unselected <=> selected', [
        animate('250ms ease-in-out')
      ]),
    ])
  ]
})
export class SuperAdminDashboardComponent {
  searchProvider: any;

  searchInsurer: any;

  userName = this.memberService.getLoginUserName();

  users: any[] = [
    { id: 1, firstName: 'Alice', lastName: 'Smith', isActive: true },
    { id: 2, firstName: 'Bob', lastName: 'Johnson', isActive: false },
    { id: 3, firstName: 'Charlie', lastName: 'Brown', isActive: true },
    { id: 4, firstName: 'Diana', lastName: 'Prince', isActive: true },
    { id: 5, firstName: 'Eve', lastName: 'Davis', isActive: false },
    { id: 6, firstName: 'Frank', lastName: 'Miller', isActive: true },
    { id: 7, firstName: 'Grace', lastName: 'Taylor', isActive: false },
    { id: 8, firstName: 'Henry', lastName: 'Wilson', isActive: true },
    { id: 9, firstName: 'Ivy', lastName: 'Moore', isActive: false },
    { id: 10, firstName: 'Jack', lastName: 'White', isActive: true },
    { id: 11, firstName: 'Karen', lastName: 'Lee', isActive: true },
    { id: 12, firstName: 'Liam', lastName: 'Hall', isActive: false },
    { id: 13, firstName: 'Mia', lastName: 'Clark', isActive: true },
    { id: 14, firstName: 'Noah', lastName: 'Lewis', isActive: false },
    { id: 15, firstName: 'Olivia', lastName: 'Young', isActive: true },
    { id: 16, firstName: 'Paul', lastName: 'King', isActive: true },
    { id: 17, firstName: 'Quinn', lastName: 'Wright', isActive: false },
  ];

  selectedUserId: number | null = null;
  currentIndex: number = 0; // Index of the first visible card
  cardsInView = 2;

  insurerIndex = 0;
  providerIndex = 0;

  selectedInsurerId: string | null = null;
  selectedProviderId!: string;
  selectedDistributorId: string | null = null;

  @Output() userSelected = new EventEmitter<any>();


  totalMonthlySales: number = 0;
  totalRolesCount: any;
  providerList: masterProvider[] = [];
  providerListTemp: masterProvider[] = [];
  isSidebarExpanded: boolean = false;
  constructor(private restService: MemberInsurerRestService, private memberService: MemberInsurerServiceService,
    private el: ElementRef, private router: Router
  ) { }

  ngOnInit(): void {
    this.memberService.sidebarExpanded$.subscribe((expanded) => {
      if (expanded) {
        this.isSidebarExpanded = false;
      } else {
        this.isSidebarExpanded = true;
      }
    });
    this.getOrgsByRole();
  }

  adminInsurerList: any[] = [];
  adminInsurerListTemp: any[] = [];
  adminProviderList: any[] = [];
  adminDistributorList: any[] = [];
  adminProviderListTemp: any[] = [];
  adminDistributorListTemp: any[] = [];

  emptyInsurerStacks: boolean = false;
  insurerDataLoading: boolean = false;
  providerDataLoading: boolean = false;
  emptyProviderStacks: boolean = false;

  getAdminInsurers() {
    this.adminInsurerList = [];

    this.restService.getAllAdminInsurers().subscribe({
      next: (response: any[]) => {
        if (response.length > 0) {
          const preferredId = 'AD-INS1753880759598';

          // Check if preferred insurer exists
          const preferredInsurer = response.find(x => x.userId === preferredId);

          if (preferredInsurer) {
            // Place preferred insurer at the top
            this.adminInsurerList = [preferredInsurer, ...response.filter(x => x.userId !== preferredId)];
            this.selectedInsurerId = preferredInsurer.userId;
          } else {
            // Fallback: use original order
            this.adminInsurerList = response;
            this.selectedInsurerId = response[0].userId;
          }

          // Keep temp copy
          this.adminInsurerListTemp = [...this.adminInsurerList];

          // Fetch stacks
          this.getInsurerAdminStacks();
          this.dataLoading = false;
        }
      },
      error: () => {
        this.adminInsurerList = [];
        this.adminInsurerListTemp = [];
      }
    });
  }


  updateChartData(monthlyData: any) {
    if (!monthlyData || monthlyData.length === 0) {
      this.chartData = { labels: [], datasets: [] };
      return;
    }

    const labels: string[] = [];
    const open: number[] = [];
    const moreInfo: number[] = [];
    const requested: number[] = [];
    const received: number[] = [];

    monthlyData.forEach((entry: any) => {
      labels.push(entry.month);
      open.push(entry.data.OPEN || 0);
      moreInfo.push(entry.data.MORE_INFO_REQUESTED || 0);
      requested.push(entry.data.REQUESTED || 0);
      received.push(entry.data.RECEIVED || 0);
    });

    this.chartData = {
      labels: labels,
      datasets: [
        {
          type: 'bar',
          label: 'Open',
          data: open,
          backgroundColor: '#A7E4F2',
          borderRadius: 6
        },
        {
          type: 'line',
          label: 'More Info Requested',
          data: moreInfo,
          borderColor: '#C9DFEE',
          backgroundColor: 'transparent',
          borderWidth: 2,
          tension: 0.3
        },
        {
          type: 'bar',
          label: 'Sent/Pending Requests',
          data: requested,
          backgroundColor: '#FDFECD',
          borderRadius: 6
        },
        {
          type: 'bar',
          label: 'Medical Evidence Received',
          data: received,
          backgroundColor: '#63d88f7a',
          borderRadius: 6
        }
      ]
    };
  }


  getAdminProviders() {
    this.adminProviderList = [];
    this.restService.getAllAdminProviders().subscribe({
      next: (response: any[]) => {
        if (response.length > 0) {
          this.adminProviderList = response;
          this.adminProviderListTemp = response;
          this.selectedProviderId = this.adminProviderList[0].organisationId; // Select the first provider by default
          this.getProviderAdminStacks();
          this.dataLoading = false;
        }
      },
      error: () => {
        this.adminProviderListTemp = [];
        this.adminProviderList = [];
      }
    });
  }

  getAdminDistributors() {
    this.adminDistributorList = [];
    this.restService.getAllAdminDistributors().subscribe({
      next: (response: any[]) => {
        if (response.length > 0) {
          this.adminDistributorList = response;
          this.adminDistributorListTemp = response;
          this.selectedProviderId = this.adminDistributorList[0].organisationId; // Select the first provider by default
          this.getAdminDistributorsStacks();
          this.dataLoading = false;
        }
      },
      error: () => {
        this.adminDistributorListTemp = [];
        this.adminDistributorList = [];
      }
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.chart) {
        this.chart.chart?.update();
      }
    }, 0);
    // Ensure calculation happens after view is rendered
    this.calculateCardsInView();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?: Event) {
    this.calculateCardsInView();
  }

  calculateCardsInView(): void {
    const container = this.el.nativeElement.querySelector('.user-carousel-view');
    if (!container) {
      this.cardsInView = 1;
      return;
    }
    const containerWidth = container.clientWidth;
    const cardWidth = 220 + 15; // Card width + gap
    this.cardsInView = Math.max(1, Math.floor(containerWidth / cardWidth));
    if (this.currentIndex > this.users.length - this.cardsInView && this.users.length >= this.cardsInView) {
      this.currentIndex = this.users.length - this.cardsInView;
    } else if (this.users.length < this.cardsInView) {
      this.currentIndex = 0;
    }
  }

  selectInsurer(user: any): void {
    this.selectedInsurerId = user.orgId;
    if (this.selectedRole == this.enumRole.PROVIDER) {
      this.selectedProviderId = user.orgId;
      this.getProviderAdminStacks();
    }
    else if (this.selectedRole == this.enumRole.DISTRIBUTOR) {
      this.selectedDistributorId = user.orgId;
      this.getAdminDistributorsStacks();
    }
    else {
      this.selectedInsurerId = user.orgId;
      this.getInsurerAdminStacks();
    }
  }

  getInsurerAdminStacks() {
    this.insurerDataLoading = true;
    this.restService.getAdminInsurerStacks(this.selectedInsurerId).subscribe({
      next: (response: DashboardSummary) => {
        if (this.isAllZero(response)) {
          this.emptyInsurerStacks = true;
        } else {
          this.emptyInsurerStacks = false;
          this.updateChartData(response.monthlyStatusSummaries);
        }

        let res = response.roleCounts;
        this.totalRolesCount = response.roleCounts;
        const adminInsurer = res['ADMIN_INSURER'] || 0;
        const totalInsurer = res['INSURER'] || 0;
        this.totalInsureres = adminInsurer + totalInsurer;

        this.lineChartData.datasets[0].data = this.generateCurveData(adminInsurer, totalInsurer);
        if (this.chart) {
          this.chart.chart?.update();
        }

        this.insurerDataLoading = false;
      },
      error: () => {
        console.error('Failed to fetch insurer stacks');
        this.emptyInsurerStacks = true;
      }
    });
  }

  getAdminDistributorsStacks() {
    this.insurerDataLoading = true;
    this.restService.getDistributorStacks(this.selectedInsurerId).subscribe({
      next: (response: DashboardSummary) => {
        if (this.isAllZero(response)) {
          this.emptyInsurerStacks = true;
        } else {
          this.emptyInsurerStacks = false;
          this.updateChartData(response);
        }

        let res = response.roleCounts;
        this.totalRolesCount = response.roleCounts;
        const adminInsurer = res['ADMIN_DISTRIBUTOR'] || 0;
        const totalInsurer = res['DISTRIBUTOR'] || 0;
        this.totalInsureres = adminInsurer + totalInsurer;

        this.lineChartData.datasets[0].data = this.generateCurveData(adminInsurer, totalInsurer);
        if (this.chart) {
          this.chart.chart?.update();
        }

        
        this.insurerDataLoading = false;
      },
      error: () => {
        console.error('Failed to fetch insurer stacks');
        this.emptyInsurerStacks = true;
      }
    });
  }

  private isAllZero(response: DashboardSummary | DashboardSummary[]): boolean {
    if (Array.isArray(response)) {
      return response.every(item =>
        item.monthlyStatusSummaries.every(summary =>
          Object.values(summary.data).every(val => val === 0)
        )
      );
    } else {
      return response.monthlyStatusSummaries.every(summary =>
        Object.values(summary.data).every(val => val === 0)
      );
    }
  }



  // Add to your component class
  hoveredRole: string | null = null;
  selectedRole: string = 'INSURER'; // default, or set as needed
  enumRole = Roles;
  dataLoading: boolean = false;

  selectRole(role: string) {
    this.dataLoading = true;
    this.selectedRole = role;
    this.getOrgsByRole();
    // if (role == this.enumRole.PROVIDER)
    //   this.getAdminProviders();
    // else if (role == this.enumRole.DISTRIBUTOR)
    //   this.getAdminDistributors();
    // else
    //   this.getAdminInsurers();
  }

  orgList: any[] = [];
  orgTempList: any[] = [];
  getOrgsByRole() {
    this.orgList = [];
    this.orgTempList = [];
    this.restService.getOrgsByRole(this.selectedRole).subscribe({
      next: (response: any) => {
        this.orgList = response;
        this.orgTempList = response;
        this.selectInsurer(this.orgList[0]);
        this.dataLoading = false;
      },
      error: () => {
        this.orgList = [];
        this.orgTempList = [];
      }
    });
  }

  getAdminList() {
    if (this.selectedRole == this.enumRole.PROVIDER)
      return this.adminProviderList;
    else if (this.selectedRole == this.enumRole.DISTRIBUTOR)
      return this.adminDistributorList;
    else
      return this.adminInsurerList;
  }

  getProviderAdminStacks() {
    this.providerDataLoading = true;
    this.restService.getAdminProviderStacks(this.selectedProviderId).subscribe({
      next: (response: DashboardSummary) => {
        // PROVIDER chart counts
        this.totalRolesCount = response.roleCounts;

        const adminProvider = response.roleCounts['ADMIN_PROVIDER'] || 0;
        const totalProvider = response.roleCounts['PROVIDER'] || 0;
        this.totalProviders = adminProvider + totalProvider;
        this.totalInsureres = this.totalProviders;

        // Step 1: Initialize totals
        const totals: StatusDataForProvider = {
          OPEN: 0,
          INPROGRESS: 0,
          MORE_INFO_REQUESTED: 0,
          COMPLETED: 0,
          REQUESTED: 0,
          RECEIVED: 0
        };

        // Step 2: Aggregate all months
        response.monthlyStatusSummaries.forEach(monthData => {
          const data = monthData.data;
          (Object.keys(totals) as (keyof StatusDataForProvider)[]).forEach(key => {
            totals[key] = (totals[key] ?? 0) + (data[key] ?? 0);
          });
        });

        // Step 3: Build chart data
        this.chartData = {
          labels: ['Open', 'In Progress', 'More Info Requested', 'Completed'],
          datasets: [
            {
              data: [
                totals.OPEN ?? 0,
                totals.INPROGRESS ?? 0, // using API key directly
                totals.MORE_INFO_REQUESTED ?? 0,
                totals.COMPLETED ?? 0
              ],
              backgroundColor: ['#A7E4F2', '#FDFECD', '#C9DFEE', '#C9F2DF'],
              borderWidth: 2,
              borderRadius: 10,
              hoverOffset: 12
            }
          ]
        };

        this.lineChartData.datasets[0].data = this.generateCurveData(adminProvider, totalProvider);
        this.lineChartData.labels = ['Start', 'Step 1', 'Step 2', 'Step 3', 'Now'];

        if (this.chart) {
          this.chart.chart?.update();
        }

        this.emptyProviderStacks = this.isAllZeroProvider(response);

        this.providerDataLoading = false;
      },
      error: () => {
        this.providerDataLoading = false;
      }
    });
  }

  private isAllZeroProvider(response: DashboardSummary): boolean {
    return response.monthlyStatusSummaries.every(summary => {
      const values = Object.values(summary.data);
      return values.every(val => val === 0);
    });
  }

  cardWidth: number = 220; // Width of a single card as defined in SCSS
  cardMarginRight: number = 15;

  nextInsurerCard(): void {
    // Ensure we don't go past the end of the list
    if (this.insurerIndex + this.cardsInView < this.orgList.length) {
      this.insurerIndex += 1; // Move one card at a time for smoother scrolling
      // Or move by cardsInView if you want to jump a whole page
      // this.insurerIndex += this.cardsInView;
    }
  }

  prevInsurerCard(): void {
    // Ensure we don't go below 0
    this.insurerIndex = Math.max(this.insurerIndex - 1, 0); // Move one card at a time
    // Or move by cardsInView if you want to jump a whole page
    // this.insurerIndex = Math.max(this.insurerIndex - this.cardsInView, 0);
  }

  get canGoNextInsurer(): boolean {
    // We can go next if the current index + the number of cards in view is less than the total list length
    // Adjusted logic: If the start of the next 'page' is within bounds of the list
    return this.insurerIndex < this.orgList.length - this.cardsInView;
  }

  get canGoPrevInsurer(): boolean {
    return this.insurerIndex > 0;
  }

  // Helper to calculate the transform value based on insurerIndex
  get carouselTransform(): string {
    const translateValue = this.insurerIndex * (this.cardWidth + this.cardMarginRight);
    return `translateX(-${translateValue}px)`;
  }

  onSearchInsurer(): void {
    this.insurerIndex = 0; // Reset carousel position on search
    const searchTerm = this.searchInsurer.toLowerCase().trim();

    if (searchTerm) {
      this.orgList = this.orgTempList.filter(user =>
        user.tradingName?.toLowerCase().includes(searchTerm)
      );
    } else {
      // If search term is empty, show all original insurers
      this.orgList = [...this.orgTempList];
    }
    // Optionally deselect any selected insurer if it's no longer in the filtered list
    if (this.selectedInsurerId && !this.orgList.some(u => u.orgId === this.selectedInsurerId)) {
      this.selectedInsurerId = null;
    }
  }

  nextProviderCard(): void {
    if (this.providerIndex < this.adminProviderListTemp.length - this.cardsInView) {
      this.providerIndex += 1; // Move one card at a time
    }
  }

  prevProviderCard(): void {
    this.providerIndex = Math.max(this.providerIndex - 1, 0); // Move one card at a time
  }

  get canGoNextProvider(): boolean {
    return this.providerIndex < this.adminProviderListTemp.length - this.cardsInView;
  }

  get canGoPrevProvider(): boolean {
    return this.providerIndex > 0;
  }

  get carouselProviderTransform(): string { // Specific transform for Provider
    const translateValue = this.providerIndex * (this.cardWidth + this.cardMarginRight);
    return `translateX(-${translateValue}px)`;
  }


  public chartType: ChartType = 'bar';

  public chartData: ChartConfiguration['data'] = {
    labels: [],
    datasets: []
  };

  public chartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom'
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        backgroundColor: '#fff',
        borderColor: '#ccc',
        borderWidth: 1,
        titleColor: '#222',
        bodyColor: '#333',
        padding: 10
      }
    },
    scales: {
      x: {
        ticks: {
          display: false,
          color: '#555'
        }
      },
      y: {
        beginAtZero: true,
        ticks: {
          color: '#555'
        }
      }
    }
  };

  public chartType2: ChartType = 'doughnut';

  public chartData2: ChartConfiguration['data'] = {
    labels: [],
    datasets: []
  };

  public chartOptions2: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'right',
        labels: {
          color: '#333',
          padding: 20,
          usePointStyle: true,
          pointStyle: 'circle'
        }
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        backgroundColor: '#fff',
        titleColor: '#333',
        bodyColor: '#666',
        borderColor: '#ccc',
        borderWidth: 1
      }
    }
  };



  onSearch(): void {
    this.providerIndex = 0; // Reset carousel position on search
    const searchTerm = this.searchProvider.toLowerCase().trim();

    if (searchTerm) {
      this.adminProviderListTemp = this.adminProviderList.filter(user =>
        user.firstName.toLowerCase().includes(searchTerm) ||
        user.lastName.toLowerCase().includes(searchTerm)
      );
    } else {
      // If search term is empty, show all original insurers
      this.adminProviderListTemp = [...this.adminProviderList];
    }
    // Optionally deselect any selected insurer if it's no longer in the filtered list
    if (this.selectedInsurerId && !this.adminProviderListTemp.some(u => u.id === this.selectedInsurerId)) {
      this.selectedInsurerId = null;
    }
  }
  @ViewChild('chart', { static: false }) chart?: BaseChartDirective;

  public totalInsureres: number = 0;
  public totalProviders: number = 0;

  public lineChartData: ChartData<'line'> = {
    datasets: [{ data: [], label: 'Insurer Growth', borderColor: 'rgba(54, 162, 235, 1)', backgroundColor: 'rgba(54, 162, 235, 0.2)', fill: 'origin', pointRadius: 0, tension: 0.4, borderWidth: 2, pointBorderColor: 'transparent', pointBackgroundColor: 'transparent' }],
    labels: []
  };

  public lineChartOptions: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    elements: { line: { tension: 0.4 } },
    scales: {
      x: { display: false },
      y: { display: false, beginAtZero: true }
    },
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false }
    }
  };

  public lineChartType: ChartType = 'line';

  // Reusable curve data generator
  generateCurveData(start: number, end: number, steps: number = 5): number[] {
    const data: number[] = [];
    for (let i = 1; i <= steps; i++) {
      const value = start + ((end - start) * (i / steps));
      data.push(Math.round(value));
    }
    return data;
  }

  onArrowClick() {
    this.router.navigate(['/dashboard/addAdmins']);
  }

  selectedTab: 'insurer' | 'provider' | 'distributor' = 'insurer';


  selectTab(tab: 'insurer' | 'provider' | 'distributor') {
    this.selectedTab = tab;
  }

  getSelectedOrganisationName(): string {
    const selected = this.orgList?.find(user => user.orgId === this.selectedInsurerId);
    return selected?.tradingName || '-';
  }
}
